import React, { FC, memo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Invoice, InvoiceCard } from 'entities/Invoice';

interface InvoiceModalProps {
  invoice: Nullable<Invoice>;
  onClose: () => void;
}

export const InvoiceModal: FC<InvoiceModalProps> = memo((props) => {
  const { invoice, onClose } = props;

  return (
    <Modal isOpen={Boolean(invoice)} onClose={onClose} width={600}>
      <div className="pt-10">
        <div className="max-h-[calc(100vh-115px)] overflow-y-auto pr-3 ">
          {invoice && <InvoiceCard invoice={invoice} defaultOpened={true} />}
        </div>
      </div>
    </Modal>
  );
});
